const browser = require("browser-detect");

const defaults = {
  api_client_id: "fridge_admin",
  default_route: "",
  browser: browser(),
};

const getConfig = (env) => {
  switch (env) {
    case "production":
      return {
        ...defaults,
        env,
        api_uri: "https://api.fridgecms.com/v2",
        stripeKey: "pk_live_nYqvku3h4OYa04LphssgBuix",
      };
    case "development":
    default:
      return {
        ...defaults,
        env,
        // api_uri: 'http://localhost:9393/api/v1',
        api_uri: "https://api.fridgecms.com/v2",
        // api_uri: 'http://34.197.229.45/v1',
        // stripeKey: "pk_test_j3j5Kr9CYKf4UImpdrVssC2q",
        stripeKey: "pk_live_nYqvku3h4OYa04LphssgBuix",
      };
  }
};

const config = getConfig(process.env.NODE_ENV);
export default config;



// WEBPACK FOOTER //
// ./app/config.js